module.exports = __webpack_public_path__ + "img/LC.126273d8.svg";